// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bbc904fa","453":"5812a206","455":"5d1c877f","977":"9766e1ee"}[chunkId] + ".chunk.js";
};